import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import moment from 'moment';
import flatpickr from 'flatpickr';
import Typography from '@material-ui/core/Typography';
import { Field } from 'redux-form';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { TextField } from '@material-ui/core';
import { required, maxLength10 } from '../../utilities/validators';
import ViewableTextField from '../../fields/reduxForm/ViewableTextField';
import JHLogoIcon from '../JHLogoIcon';
import Button from '../Button';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  user: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitFn: PropTypes.func,
  change: PropTypes.func,
};

const styles = {
  buildingLicField: {
    width: '100%',
    marginTop: '1rem',
  },
};

const LicenseExpiryModal = ({
  classes,
  onClose,
  isOpen,
  user,
  handleSubmit,
  submitFn,
  change,
}) => {
  const [expiryValue, setexpiryValue] = useState('');
  useEffect(() => {
    const datePicker = document.querySelector(
      '#building-licence-expiry-modal-datepicker',
    );
    if (datePicker) {
      enableDatePicker(datePicker);
    }
  });

  const enableDatePicker = async datePicker => {
    const options = {
      dateFormat: 'd-m-Y',
      minDate: 'today',
      disableMobile: true,
      static: true,
      onChange: () => {
        handleDateChange(flatpicker);
      },
    };
    const flatpicker = await flatpickr(datePicker, options);
    if (flatpicker.calendarContainer) {
      flatpicker.calendarContainer.style.fontFamily = '"Helvetica Neue", Arial';
      // override position - date picker is rendersd inside modal due to IE bug
      flatpicker.calendarContainer.style.top = '-175px';
    }
  };

  const handleDateChange = flatpicker => {
    const [selectedDate] = flatpicker.selectedDates;
    const formValue = moment(selectedDate.toISOString()).format('DD-MM-YYYY');
    change('custom:buildingLicExp', `${formValue}`);
    setexpiryValue(formValue);
  };

  const formFields = [
    {
      name: 'custom:buildingLicNo',
      component: ViewableTextField,
      props: {
        id: 'building-licence-number-modal-text-field',
        label: 'Builder Licence Number',
        fullWidth: true,
        disabled: true,
      },
      normalize: null,
      isEditable: false,
      initialValue: user['custom:buildingLicNo'],
    },
    {
      name: 'custom:buildingLicExp',
      component: ViewableTextField,
      props: {
        id: 'building-licence-expiry-modal-text-field',
        label: 'Builder Licence Expiry',
        fullWidth: true,
      },
      validate: [required, maxLength10],
      normalize: null,
      isEditable: true,
    },
  ];

  return (
    <Dialog
      onClose={onClose}
      disableBackdropClick
      aria-labelledby="License Expiry Modal"
      open={isOpen}
      maxWidth="lg"
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <Toolbar className={classes.toolBar}>
        <JHLogoIcon />
      </Toolbar>
      <Card className={classes.cardRoot}>
        <CardContent>
          <form className={classes.root} onSubmit={handleSubmit(submitFn)}>
            <Typography variant="h5" className={classes.formTitle}>
              License Expiry
            </Typography>
            <Typography variant="subtitle2" className={classes.subTitle}>
              Please provide your builder license expiry
            </Typography>
            {formFields.map(field => (
              <div className={classes.hidden} key={field.name}>
                <Field
                  name={field.name}
                  component={field.component}
                  props={field.props}
                  validate={field.validate}
                  isEditing={field.isEditable}
                  normalize={field.normalize}
                  textValue={field.initialValue}
                  initialValue={field.initialValue}
                />
              </div>
            ))}
            <div className={classes.formGroup}>
              <TextField
                label={formFields[0].props.label}
                style={styles.buildingLicField}
                value={formFields[0].initialValue}
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="building-licence-expiry-modal-datepicker"
                label={formFields[1].props.label}
                style={styles.buildingLicField}
                value={expiryValue}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </div>

            <div className={classes.formButtons}>
              <Button type="submit" variant="contained" color="primary">
                Done
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </Dialog>
  );
};

LicenseExpiryModal.propTypes = propTypes;

export default LicenseExpiryModal;
